import { Popover, Backdrop } from "@mui/material";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { useRef, useState } from "react";
import { UserMenu } from "Components/Layout/Menu/UserMenu/UserMenu";
import { Avatar } from "Components/Shared/Avatar/Avatar";

export const AvatarWithPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const avatarRef = useRef<HTMLDivElement>(null);
  const user = useLoggedInUser();

  if (!user) {
    return null;
  }

  return (
    <>
      <Avatar
        elementRef={avatarRef}
        user={user}
        size="small"
        onClick={() => setIsOpen(!isOpen)}
      />
      <Backdrop
        open={isOpen}
        onClick={() => setIsOpen(false)}
        sx={{
          zIndex: ({ zIndex }) => zIndex.modal - 1,
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.1)",
        }}
      />
      <Popover
        open={isOpen}
        anchorEl={avatarRef.current}
        onClose={() => setIsOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: { mt: 3, minWidth: 280, borderRadius: 2 } } }}
      >
        <UserMenu onActionTriggered={() => setIsOpen(false)} />
      </Popover>
    </>
  );
};
